import RadioTemplate from '../../html/components/radio.html'
import RadioGroupTemplate from '../../html/components/radio-group.html'

import Component from '../shared/component'
import Relation, {HasMany, MemberOf} from '../shared/mixins/relation'

import {FormControlMixin} from './form'

const radioGroup = Relation()

export const Radio = Component('v-radio', {
  model: {
    prop: 'checked',
    event: 'change'
  },
  mixins: [
    MemberOf(radioGroup, 'group')
  ],
  template: RadioTemplate,
  props: {
    value: {
      default: null
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      active: this.checked
    }
  },
  computed: {
    tabindex () {
      if (this.active) {
        return null
      }

      if (this.group && !this.group.active && this.group.radios[0] === this) {
        return null
      }

      return -1
    }
  },
  watch: {
    checked () {
      this.active = this.checked
    },

    active () {
      this.$emit('change', this.active)
    }
  },
  methods: {
    select () {
      if (!this.active) {
        this.active = true
      }
    },

    deselect () {
      if (this.active) {
        this.active = false
      }
    }
  }
})

export const RadioGroup = Component('v-radio-group', {
  mixins: [
    HasMany(radioGroup, 'radios'),
    FormControlMixin('radio')
  ],
  template: RadioGroupTemplate,
  props: {
    name: {
      type: String,
      default: null
    },
    value: {
      default: null
    }
  },
  computed: {
    index () {
      return this.radios.findIndex(radio => this.active === radio.value)
    }
  },
  watch: {
    active () {
      this.radios.forEach(radio => {
        if (this.active === radio.value) {
          radio.select()
        } else {
          radio.deselect()
        }
      })
    },

    radios () {
      this.radios.forEach(radio => {
        if (this.active === null && radio.active) {
          this.select(radio.value)
        }

        if (this.active === radio.value) {
          radio.select()
        } else {
          radio.deselect()
        }

        radio.$on('change', active => active
          ? this.select(radio.value)
          : null
        )
      })
    }
  },
  methods: {
    select (value) {
      this.active = value
    },

    selectIndex (index) {
      index %= this.radios.length

      if (index < 0) {
        index += this.radios.length
      }

      const radio = this.radios[index]

      this.select(radio.value)

      radio.$refs.interactive.$el.focus()
    },

    next () {
      this.selectIndex(this.index + 1)
    },

    prev () {
      this.selectIndex(this.index - 1)
    }
  }
})
